export const IS_LOADING_VISITOR = "IS_LOADING_VISITOR";
export const VISITOR_SUCCESS = "VISITOR_SUCCESS";
export const VISITOR_FAILED = "VISITOR_FAILED";


export const ADD_TOKEN = "ADD_TOKEN";

export const ADD_VISITOR_MSG = "ADD_VISITOR_MSG";
export const REMOVE_VISITOR_MSG = "REMOVE_VISITOR_MSG";
